import defaultApp from './defaultApp.js';

import ProductItem from './components/ProductItem.vue';

import constants from '../constants.js';

const productsApp = {
    ...defaultApp,
    components: { ...defaultApp.components, ProductItem },
    computed: {
        ...defaultApp.computed,
        groupedItems() {
            const uncategorizedLabel = this.dataUncategorizedLabel;
            const grouped = this.data.items.reduce((acc, item) => {
                // Check if the item has a 'type' array and at least one element
                const category = item.productType && item.productType.length > 0 ? item.productType[0].name : uncategorizedLabel;
                if (!acc[category]) {
                    acc[category] = [];
                }
                acc[category].push(item);
                return acc;
            }, {});

            const sortedGrouped = Object.entries(grouped).sort(([keyA], [keyB]) => {
                const types = this.data.facets.find(f => f.alias === constants.keys.productType).options;

                const indexA = types.findIndex(type => type.valueAlias === keyA);
                const indexB = types.findIndex(type => type.valueAlias === keyB);

                if (keyA === uncategorizedLabel) return 1;
                if (keyB === uncategorizedLabel) return -1;

                if (indexA !== -1 && indexB !== -1) {
                    return indexA - indexB;
                }

                if (indexA !== -1) return -1;
                if (indexB !== -1) return 1;

                return keyA.localeCompare(keyB);
            });

            return Object.fromEntries(sortedGrouped);
        },
    }
};

export default productsApp;
